import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingComponent } from './loading.component';
import { LoadingBackdropComponent } from './loading-backdrop.component';
import { LoadingConfig } from './loading-config';
import { LoadingService } from './loading.service';
import { PromiseTrackerService } from './promise-tracker.service';

@NgModule({
  imports: [CommonModule],
  declarations: [LoadingComponent, LoadingBackdropComponent],
  entryComponents: [LoadingComponent, LoadingBackdropComponent]
})
export class LoadingModule {
  static forRoot(config: LoadingConfig = {}): ModuleWithProviders<LoadingModule> {
    return {
      ngModule: LoadingModule,
      providers: [
        LoadingService,
        PromiseTrackerService,
        { provide: LoadingConfig, useValue: config }
      ]
    };
  }
}
